import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { z } from 'zod';
import { de, en } from 'zod/locales';

// Set initial Zod locale to German (default)
z.config(de());

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'de',
    supportedLngs: ['de', 'en'],
    defaultNS: 'common',
    ns: ['common', 'dashboard', 'appointments', 'calendar', 'availability', 'settings', 'login', 'video', 'versicherte'],

    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'jourfx-language',
    },

    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: true,
    },

    saveMissing: import.meta.env.DEV,
    missingKeyHandler: (_lngs, ns, key) => {
      console.warn(`[i18n] Missing key: ${ns}:${key}`);
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  // Update Zod locale when language changes
  if (lng === 'de') {
    z.config(de());
  } else {
    z.config(en());
  }
});

export default i18n;
